// @flow

import bcpSrc from './bcp.png';
import crecerSrc from './crecer.png';
import ebisaSrc from './ebisa.png';
import ecofuturoSrc from './ecofuturo.png';
import farmacorpSrc from './farmacorp.png';
import fassilSrc from './fassil.png';
import primeraSrc from './primera.png';
import prodemSrc from './prodem.png';

export function getBrandImageSource(bankCode: string): string {
  switch (bankCode) {
    case 'bcp':
      return bcpSrc;
    case 'crecer':
      return crecerSrc;
    case 'ebisa':
      return ebisaSrc;
    case 'ecofuturo':
      return ecofuturoSrc;
    case 'farmacorp':
      return farmacorpSrc;
    case 'fassil':
      return fassilSrc;
    case 'primera':
      return primeraSrc;
    case 'prodem':
      return prodemSrc;
    default:
      throw new Error(`Brand "${bankCode}" not found`);
  }
}
